import React from "react";

// Add missing props interface
interface ChartVisualConfigProps {
  showAreaGradient: boolean;
  setShowAreaGradient: (value: boolean) => void;
  showCrosshair: boolean;
  setShowCrosshair: (value: boolean) => void;
  showGridRows: boolean;
  setShowGridRows: (value: boolean) => void;
  showGridColumns: boolean;
  setShowGridColumns: (value: boolean) => void;
  showPatternBackground: boolean;
  setShowPatternBackground: (value: boolean) => void;
  smoothLines: boolean;
  setSmoothLines: (value: boolean) => void;
  showXAxis: boolean;
  setShowXAxis: (value: boolean) => void;
  showYAxis: boolean;
  setShowYAxis: (value: boolean) => void;
  isOpen: boolean;
  onClose: () => void;
  resetToDefaults: () => void;
}

import Drawer from "@/components/ui/drawer";
import { Switch } from "@/components/ui/switch/Switch";

const ChartVisualConfig: React.FC<ChartVisualConfigProps> = ({
  showAreaGradient,
  setShowAreaGradient,
  showCrosshair,
  setShowCrosshair,
  showGridRows,
  setShowGridRows,
  showGridColumns,
  setShowGridColumns,
  showPatternBackground,
  setShowPatternBackground,
  smoothLines,
  setSmoothLines,
  showXAxis,
  setShowXAxis,
  showYAxis,
  setShowYAxis,
  isOpen,
  onClose,
  resetToDefaults,
}) => {
  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      title="Chart Settings"
      width="max-w-xs"
    >
      <div className="space-y-4 text-white">
        {/* Visual Options */}
        <div className="space-y-4 flex flex-col px-4">
          <label htmlFor="smoothLines" className="flex gap-2">
            <Switch
              checked={smoothLines}
              onChange={() => setSmoothLines(!smoothLines)}
            />
            <span>Smooth Lines</span>
          </label>
          <label htmlFor="showAreaGradient" className="flex gap-2">
            <Switch
              checked={showAreaGradient}
              onChange={() => setShowAreaGradient(!showAreaGradient)}
            />
            <span>Area Gradient</span>
          </label>
          <label htmlFor="showCrosshair" className="flex gap-2">
            <Switch
              checked={showCrosshair}
              onChange={() => setShowCrosshair(!showCrosshair)}
            />
            <span>Crosshair</span>
          </label>
          <label htmlFor="showGridRows" className="flex gap-2">
            <Switch
              checked={showGridRows}
              onChange={() => setShowGridRows(!showGridRows)}
            />
            <span>Grid Y</span>
          </label>
          <label htmlFor="showGridColumns" className="flex gap-2">
            <Switch
              checked={showGridColumns}
              onChange={() => setShowGridColumns(!showGridColumns)}
            />
            <span>Grid X</span>
          </label>
          <label htmlFor="showXAxis" className="flex gap-2">
            <Switch
              checked={showXAxis}
              onChange={() => setShowXAxis(!showXAxis)}
            />
            <span>Show X Axis</span>
          </label>
          <label htmlFor="showYAxis" className="flex gap-2">
            <Switch
              checked={showYAxis}
              onChange={() => setShowYAxis(!showYAxis)}
            />
            <span>Show Y Axis</span>
          </label>
          <label htmlFor="showPatternBackground" className="flex gap-2">
            <Switch
              checked={showPatternBackground}
              onChange={() => setShowPatternBackground(!showPatternBackground)}
            />
            <span>Pattern Background</span>
          </label>
        </div>
      </div>
    </Drawer>
  );
};

export default ChartVisualConfig;
